import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchGuaranteeLetters = createAsyncThunk(
    'contract/fetchGuaranteeLetters',
    async ({ PolicyID }: { PolicyID: string }, { rejectWithValue }) => {
        try {
            const response = await getRequest({ 'PolicyID': PolicyID }, 'dms-hr', 'getGuaranteeLetters', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { GuaranteeLetters: data.GuaranteeLetters, PolicyID, fetchTime: parseToTimestamp(new Date()) };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchDownloadhGuaranteeLetter = createAsyncThunk(
    'contract/fetchDownloadhGuaranteeLetter',
    async ({ GuaranteeLetterID }: { GuaranteeLetterID: string }, { rejectWithValue }) => {
        try {
            const response = await getRequest({ 'GuaranteeLetterID': GuaranteeLetterID }, 'dms-hr', 'downloadGuaranteeLetterFile', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileName: data.File.Name, FileData: data.File.DataBase64 };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchSendGuaranteeLetter = createAsyncThunk(
    'contract/fetchSendGuaranteeLetter',
    async ({ GuaranteeLetterID, Email }: { GuaranteeLetterID: string, Email: string }, { rejectWithValue }) => {
        try {
            const response = await getRequest({ 'GuaranteeLetterID': GuaranteeLetterID, "Email": Email }, 'dms-hr', 'sendGuaranteeLetter', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileName: data.FileName, FileData: data.FileData };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);